/**
 * Bank rows for the shared question catalog.
 * Stems, status, and AI Spotted come from `question-catalog`.
 */

import { QUESTION_CATALOG } from "@/lib/mock/question-catalog"
import { NAV_USER } from "@/lib/mock/navigation"
import type { LibraryItem } from "@/lib/mock/library"

export const AI_SPOTTED_CASE_ITEMS: LibraryItem[] = QUESTION_CATALOG.map((row) => ({
  id: `ai-case-${row.id}`,
  questionId: row.questionId,
  title: row.title || undefined,
  stem: row.stem,
  topic: "Biochemistry",
  status: row.status,
  type: row.type,
  difficulty: row.difficulty === "" ? "" : row.difficulty,
  author: NAV_USER.name,
  authorEmail: NAV_USER.email,
  updatedAt: "2026-09-24",
  folderId: "laboratory-interpretation",
  bloomLevel: row.bloomLevel,
  pbi: row.pbi,
  ptBiserial: row.pbi,
  usageCount: row.usageCount,
  examUsageCount: row.usageCount,
  version: "v1",
  aiSpotted: row.aiSpotted,
  fixedSummary: row.fixedSummary,
  ...(row.categoryIds === null
    ? { categoryIds: [] as string[], categoryUnassigned: true }
    : row.categoryIds?.length
      ? { categoryIds: [...row.categoryIds] }
      : {}),
  ...(row.options?.length ? { options: row.options } : {}),
}))
